import { Pagination, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import '../../../Styles/UserThresholdLimitQuestions.css'
import { useTranslation } from 'react-i18next'
import { UOM_AMOUNT_ID, UOM_NUMBER_ID, UOM_PERCENTAGE_ID } from 'src/Entities/Governance'
import { useCompStore } from 'src/Components/Governance/Store/ComplianceStore'
import { cn, compAnswerDateConvert, featValid } from 'src/lib/utils'
import EditPencilIcon from 'src/Common/Icon/EditPencilIcon'
import ContentCircle from 'src/Common/ui/contentCircle'
import { UPDATE_COMPLIANCE } from 'src/Entities/Features'

function UserThresholdLimitQuestions ({ setEditState, setEditData, setDrawType, setValue, inputValidation, trigger, activeTab, selectedValues, controls, control, data, errors, onInputChangeTextArea, onValueSelectChange, onInputChange, handleAddControls, handleDeleteControls, i }) {
    const viewCondition = () => {
        const path = location.pathname
        return path.includes('view-complaince')
    }
    const { getCompUom } = useCompStore()
    useEffect(() => {
        getCompUom()
    }, [])
    const uomSymbol = (value) => {
        switch (value) {
        case UOM_PERCENTAGE_ID:
            return '%'
        case UOM_NUMBER_ID:
            return ''
        case UOM_AMOUNT_ID:
            return ''
        default:
            break
        }
    }
    const [ paginatedData, setPaginatedData ] = useState([])
    const [ currentPage, setCurrentPage ] = useState(1)
    const { t } = useTranslation()
    const rowsPerPage = 5
    const totalPages = Math.ceil(data.length / rowsPerPage)
    const handlePageChange = (event, value) => {
        setCurrentPage(value)
    }

    useEffect(() => {
        if (data.length > 0) {
            if (viewCondition()) {
                setPaginatedData(data.map((item, i) => ({ ...item, sNo: i + 1 })).slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage))
            } else {
                setPaginatedData(data.map((item, i) => ({ ...item, sNo: i + 1 })))
            }
        }
    }, [ data, currentPage ])

    const handleEditClick = (data) => {
        setEditState({ right: true })
        setDrawType('threshold')
        setEditData(data)
    }
    const features = JSON.parse(localStorage.getItem('features'))

    return (
        <>
            {<div style={{ display: activeTab === 3 ? 'block' : 'none', height: '100%' }}>
                <div className='h-[80%]'>
                    <TableContainer className={'user-threshold-comp-table global-table'}>
                        <Table >
                            <TableHead>
                                <TableRow>
                                    <TableCell align='center' sx={{ border: 'none', position: 'sticky', left: 0 }} colSpan={2}></TableCell>
                                    <TableCell align='center' sx={{ }} colSpan={2}>{t('Applicable limit')}</TableCell>
                                    <TableCell sx={{ }} align='center' colSpan={2}><p className={cn('comp-table-th pl-2')}>{t('Regulatory limit')}</p></TableCell>
                                    <TableCell sx={{ }} align='center' colSpan={2}><p className={cn('comp-table-th pl-2')}>{t('Invested')}</p></TableCell>
                                    <TableCell sx={{ }} align='center' colSpan={2}><p className={cn('comp-table-th pl-2')}>{t('Market value')}</p></TableCell>
                                    <TableCell sx={{ }} align='center' colSpan={1}></TableCell>
                                    <TableCell sx={{ }} align='center' colSpan={2}><p className={cn('')}>{t('Risk of Non-Compliance limit')}</p></TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell align='center' sx={{ position: 'sticky', left: 0 }}><p className='flex justify-center'>#</p></TableCell>
                                    <TableCell align='center' sx={{ position: 'sticky', left: '100px' }}><p style={{ borderRight: '1.5px solid hsl(var(--table-bisector))' }} className='h-[60px] flex items-center'><p className={cn('comp-table-th pl-2 min-w-[200px]')}>{t('Description')}</p></p></TableCell>
                                    <TableCell align='center' sx={{ }}><p className={cn('pl-2')}>{t('Minimum')}</p></TableCell>
                                    <TableCell align='center' sx={{ }}><p className={cn('comp-table-th pl-2')}>{t('Maximum')}</p></TableCell>
                                    <TableCell align='center' sx={{ }}><p className={cn('comp-table-th pl-2')}>{t('Minimum')}</p></TableCell>
                                    <TableCell align='center' sx={{ }}><p className={cn('comp-table-th pl-2')}>{t('Maximum')}</p></TableCell>
                                    <TableCell align='center' sx={{ }}><p className={cn('comp-table-th pl-2')}>{t('Amount')}</p></TableCell>
                                    <TableCell align='center' sx={{ }}><p className={cn('comp-table-th pl-2')}>{t('As on')}</p></TableCell>
                                    <TableCell align='center' sx={{ }}><p className={cn('comp-table-th pl-2')}>{t('Amount')}</p></TableCell>
                                    <TableCell align='center' sx={{ }}><p className={cn('comp-table-th pl-2')}>{t('As on')}</p></TableCell>
                                    <TableCell align='center' sx={{ }}><p className={cn('comp-table-th pl-2')}>{t('Remarks')}</p></TableCell>
                                    {/* <TableCell align='center' sx={{ }}><p className={cn('comp-table-th pl-2')}>{t('Fine Amount')}</p></TableCell> */}
                                    <TableCell align='center' sx={{ }}><p className={cn('comp-table-th pl-2')}>{t('Penalties and fines')}</p></TableCell>
                                    <TableCell align='center' sx={{ }}><p className={cn('comp-table-th pl-2')}>{t('Damage to Reputation')}</p></TableCell>
                                    <TableCell align='center' sx={{ position: 'sticky', right: 0 }}><p className={cn('comp-table-th pl-2')}></p></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    paginatedData?.map((item, j) => {
                                        return (
                                            <>
                                                <TableRow>
                                                    <TableCell align='center' sx={{ position: 'sticky', left: 0, zIndex: 2 }}>
                                                        <div className='w-full flex justify-center'>
                                                            <ContentCircle className={'min-h-6 text-center bg-[hsl(var(--primary-table-head))] min-w-6'} contentClassName={'text-primary'} content={item.sNo} />
                                                        </div>
                                                    </TableCell>
                                                    <TableCell align='center' sx={{ position: 'sticky', left: '100px', zIndex: 2 }}>
                                                        <p style={{ borderRight: '1.5px solid hsl(var(--table-bisector))' }} className='h-[60px] flex items-center'><p className={'threshold-comp-table-td'}>
                                                            <div className=' pl-2 '>{item.type}</div>
                                                        </p>
                                                        </p>
                                                    </TableCell>
                                                    <TableCell align='center'>
                                                        <p className={''}>
                                                            <div className='flex items-center justify-center'>
                                                                <div>{item.applicableLimitMin}</div>
                                                                <div>{uomSymbol(item.uom)}</div>
                                                            </div>

                                                        </p>
                                                    </TableCell>
                                                    <TableCell align='center' sx={{ }}>
                                                        <p className={'threshold-comp-table-td'}>
                                                            <div className='flex items-center justify-center'>
                                                                <div>{item.applicableLimitMax}</div>
                                                                <div>{uomSymbol(item.uom)}</div>
                                                            </div>

                                                        </p>
                                                    </TableCell>
                                                    <TableCell align='center' sx={{ }}>
                                                        <p className={'threshold-comp-table-td'}>
                                                            <div className='flex items-center justify-center'>
                                                                <div>{item.regulatoryLimitMin}</div>
                                                                <div>{uomSymbol(item.uom)}</div>
                                                            </div>

                                                        </p>
                                                    </TableCell>
                                                    <TableCell align='center' sx={{ }}>
                                                        <p className={'threshold-comp-table-td'}>
                                                            <div className='flex items-center justify-center'>
                                                                <div>{item.regulatoryLimitMax}</div>
                                                                <div>{uomSymbol(item.uom)}</div>
                                                            </div>

                                                        </p>
                                                    </TableCell>
                                                    <TableCell align='center' sx={{ }}>
                                                        <p className={'threshold-comp-table-td'}>
                                                            <div>{item?.thresholdLimitResponses[0]?.investedAmount || '-'}</div>

                                                        </p>
                                                    </TableCell>
                                                    <TableCell align='center' sx={{ }}>
                                                        <p className={'threshold-comp-table-td'}>
                                                            <div>{compAnswerDateConvert(item?.thresholdLimitResponses[0]?.investedAsOn) || '-'}</div>

                                                        </p>
                                                    </TableCell>
                                                    <TableCell align='center' sx={{ }}>
                                                        <p className={'threshold-comp-table-td'}>
                                                            <div>{item?.thresholdLimitResponses[0]?.marketValueAmount || '-'}</div>

                                                        </p>
                                                    </TableCell>
                                                    <TableCell align='center' sx={{ }}>
                                                        <p className={'threshold-comp-table-td'}>
                                                            <div>{compAnswerDateConvert(item?.thresholdLimitResponses[0]?.marketValueAsOn) || '-'}</div>

                                                        </p>
                                                    </TableCell>
                                                    <TableCell align='center' sx={{ }}>
                                                        <p className={'threshold-comp-table-td'}>
                                                            <div className='min-w-[250px]'>{item?.thresholdLimitResponses[0]?.remark || '-'}</div>

                                                        </p>
                                                    </TableCell>
                                                    {/* <TableCell align='center' sx={{ }}>
                                                        <p className={'threshold-comp-table-td'}>
                                                            <div>{item?.thresholdLimitResponses[0]?.fineAmount || '-'}</div>

                                                        </p>
                                                    </TableCell> */}
                                                    <TableCell align='center' sx={{ }}>
                                                        <p className={cn(item.penaltyandFine === 'All good' ? 'text-[hsl(var(--Low))] font-semibold' : 'text-[hsl(var(--danger))] font-semibold', 'threshold-comp-table-td')}>
                                                            <div>{item.penaltyandFine || '-'}</div>

                                                        </p>
                                                    </TableCell>
                                                    <TableCell align='center' sx={{ }}>
                                                        <p className={cn(item.damageToReputation === 'All good' ? 'text-[hsl(var(--Low))] font-semibold' : 'text-[hsl(var(--danger))] font-semibold', 'threshold-comp-table-td')}>
                                                            <div>{item.damageToReputation || '-'}</div>

                                                        </p>
                                                    </TableCell>
                                                    {featValid(features, UPDATE_COMPLIANCE) && <TableCell align='center' sx={{ position: 'sticky', right: 0 }}>
                                                        <p onClick={() => handleEditClick(item)} className={'cursor-pointer flex justify-center'}>
                                                            <EditPencilIcon />
                                                        </p>
                                                    </TableCell>}
                                                </TableRow>
                                            </>
                                        )
                                    })
                                }

                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
                {data.length > 0 && <div className="border-t-2 border-t-primary-foreground flex items-center justify-between mt-2 p-4 h-[20%]">
                    <Typography className="text-muted !text-h4">
                                Showing data {currentPage} to {rowsPerPage} of {totalPages} entries
                    </Typography>
                    <Pagination
                        sx={{ marginLeft: 'auto' }}
                        count={totalPages}
                        page={currentPage}
                        onChange={handlePageChange}
                        variant="outlined"
                        shape="rounded" />
                </div>}
            </div>}
        </>
    )
}

UserThresholdLimitQuestions.propTypes = {
    selectedValues: PropTypes.array,
    onValueSelectChange: PropTypes.func,
    controls: PropTypes.any,
    control: PropTypes.any,
    errors: PropTypes.any,
    data: PropTypes.any,
    onInputChangeTextArea: PropTypes.func,
    onInputChange: PropTypes.func,
    handleAddControls: PropTypes.func,
    handleDeleteControls: PropTypes.func,
    i: PropTypes.number,
    activeTab: PropTypes.any,
    inputValidation: PropTypes.any,
    setEditState: PropTypes.any,
    setEditData: PropTypes.any,
    setDrawType: PropTypes.any,
    setValue: PropTypes.any,
    trigger: PropTypes.any
}

export default UserThresholdLimitQuestions
